import { render, staticRenderFns } from "./ShopExport.vue?vue&type=template&id=2a8620b7&"
import script from "./ShopExport.vue?vue&type=script&lang=js&"
export * from "./ShopExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports